const ActionTypes = {
  CREATE_USER: "CREATE_USER",
  MODIFY_USER: "MODIFY_USER",
  REMOVE_USER: "REMOVE_USER",
  SAVED_CARS_REQUESTED: "SAVED_CARS_REQUESTED",
  SAVED_CARS_RECEIVED: "SAVED_CARS_RECEIVED",
  REMOVE_SAVED_CAR_REQUESTED: "REMOVE_SAVED_CAR",
  REMOVE_SAVED_CAR_RECEIVED: "REMOVE_SAVED_CAR_RECEIVED",
  ADD_SAVED_CAR_REQUESTED: "ADD_SAVED_CAR_REQUESTED",
  ADD_SAVED_CAR_RECEIVED: "ADD_SAVED_CAR_RECEIVED",
  DEALER_LOGO_CHANGE: "DEALER_LOGO_CHANGE",
  DEALER_LOGO_CHANGE_SUCCESS: "DEALER_LOGO_CHANGE_SUCCESS",
  DEALER_LOGO_CHANGE_ERROR: "DEALER_LOGO_CHANGE_ERROR",
  USER_IMAGE_CHANGE: "USER_IMAGE_CHANGE",
  USER_IMAGE_CHANGE_SUCCESS: "USER_IMAGE_CHANGE_SUCCESS",
  USER_IMAGE_CHANGE_ERROR: "USER_IMAGE_CHANGE_ERROR"
};

export default ActionTypes;
